/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FundingSource {
    Brand = 1,
    Retailer = 2,
    Joint = 3,
}
